import { KeyboardEvent } from 'react'

export const onSpaceOrEnterPressed = (
  e: KeyboardEvent,
  callback: (args?: any) => void
) => {
  if (e?.key === ' ' || e?.key === 'Enter') return callback()
}
